import Vue from "vue";
import Router from "vue-router";

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
import Layout2 from "../views/layout/Layout2";
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/initPwd",
    component: () => import("@/views/initPwd/index"),
    hidden: true
  },
  {
    path: "/wxlogin",
    component: () => import("@/views/wxlogin/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    name: "home",
    children: [
      {
        path: "home",
        name: "home",
        meta: {
          title: "home.name",
          // icon: "dashboard"
        },
        component: () => import("@/views/home")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "",
    redirect: "",
    hidden: true,
    children: [
      {
        path: "/profile/index",
        name: "/profile/index",
        component: () => import("@/views/profile/index"),
        meta: { title: "breadcumb.changePwd" }
      }
    ]
  },
  {
    path: "",
    component: Layout2,
    name: "register",
    children: [
      {
        path: "register",
        name: "register",
        meta: {
          title: "register.name",
          // icon: "dashboard"
        },
        component: () => import("@/views/register/register")
      }
    ]
  },
  {
    path: "",
    component: Layout2,
    name: "updateAuthUser",
    children: [
      {
        path: "updateAuthUser",
        name: "updateAuthUser",
        meta: {
          title: "register.updateInfo",
          // icon: "dashboard"
        },
        component: () => import("@/views/register/updateAuthUser")
      }
    ]
  },
  {
    path: "",
    component: Layout2,
    name: "updateAuthUserLLSHR",
    children: [
      {
        path: "updateAuthUserLLSHR",
        name: "updateAuthUserLLSHR",
        meta: {
          title: "register.updateInfo",
          // icon: "dashboard"
        },
        component: () => import("@/views/register/updateAuthUserLLSHR")
      }
    ]
  },
  {
    path: "",
    component: Layout2,
    name: "resetPwd",
    children: [
      {
        path: "resetPwd",
        name: "resetPwd",
        meta: {
          title: "resetPwd.name",
          // icon: "dashboard"
        },
        component: () => import("@/views/register/resetPwd")
      }
    ]
  },
];

export const asyncRoutes = [];
export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});



// WEBPACK FOOTER //
// ./src/router/index.js